import type { ComponentProps } from "react";

export default function CheckmarkCircleIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.0928 2C6.58277 2 2.09277 6.49 2.09277 12C2.09277 17.51 6.58277 22 12.0928 22C17.6028 22 22.0928 17.51 22.0928 12C22.0928 6.49 17.6028 2 12.0928 2ZM16.8728 9.7L11.2028 15.37C11.0628 15.51 10.8728 15.59 10.6728 15.59C10.4728 15.59 10.2828 15.51 10.1428 15.37L7.31277 12.54C7.02277 12.25 7.02277 11.77 7.31277 11.48C7.60277 11.19 8.08277 11.19 8.37277 11.48L10.6728 13.78L15.8128 8.64C16.1028 8.35 16.5828 8.35 16.8728 8.64C17.1628 8.93 17.1628 9.4 16.8728 9.7Z"
        fill={props.fill || "#60B527"}
      />
    </svg>
  );
}
